import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/fields/$fieldId/insights/")({
    component: RouteComponent,
    beforeLoad: async ({ search, params }) => {
        throw redirect({
            to: "/dashboard/fields/$fieldId/insights/ntime",
            params: { fieldId: params.fieldId },
            search,
        });
    },
});

function RouteComponent() {
    return null;
}
